export const enhancer = (el) => {
  const title = el.querySelector('.specs-block__title');
  const wrapper = title.querySelector('span');
  const width = wrapper.offsetWidth;
  title.style.width = `${width}px`;
};
